// ############################################################################
// ## CSS SKINS ###############################################################
// ############################################################################

import $ from "jquery"
import {$doc} from "./_globals.js";

var ATTR = "data-skin-href";

function markActive(skinHref) {
  if(skinHref) {
    $("["+ATTR+"]").each(function() {
      var $this = $(this);
      $this.toggleClass("active", $this.attr(ATTR) === skinHref);
    })
  }
}

$doc.on("click", "["+ATTR+"]", function($evt) {
  var skinHref = $(this).attr(ATTR);
  var $skinEl = $("#skin-css");

  $skinEl
    .clone()
    .one("load", () => { $skinEl.remove(); }) // remove original link after the new one is loaded
    .prop("href", skinHref)
    .insertBefore($skinEl);

  markActive(skinHref);

  if(window.localStorage) localStorage.setItem("skin-css", skinHref);

  $evt.preventDefault();
}).ready(function() {
  var skinHref = window.localStorage && localStorage.getItem("skin-css");
  if(skinHref) markActive(skinHref);
});